import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import {
  CommissaryOrdersList,
} from "./CommissaryOrdersList";
import {
  CommissaryOrderShow,
  commissaryOrderShowLoader,
} from "./CommissaryOrderShow";
import {
  CommissaryOrderCreate,
  commissaryOrderCreateLoader,
} from "./CommissaryOrderCreate";

const CommissaryOrdersIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/commissary-orders") {
    navigate("/commissary-orders/list");
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export const commissaryOrdersRouter = {
  path: "/commissary-orders",
  id: "commissary-orders",
  element: <CommissaryOrdersIndex />,
  handle: {
    crumb: () => (
      <Breadcrumb name="Commissary Orders" href="/commissary-orders/list" />
    ),
  },
  children: [
    {
      path: "list",
      id: "commissary-orders-list",
      element: <CommissaryOrdersList />,
    },
    {
      path: "create",
      id: "commissary-orders-create",
      element: <CommissaryOrderCreate />,
      loader: commissaryOrderCreateLoader,
      handle: {
        crumb: () => (
          <Breadcrumb
            name="Create Order"
            href="/commissary-orders/create"
          />
        ),
      },
    },
    {
      path: ":id",
      id: "commissary-orders-show",
      element: <CommissaryOrderShow />,
      loader: commissaryOrderShowLoader,
      handle: {
        crumb: () => (
          <Breadcrumb name="Order Details" href="#" />
        ),
      },
    },
  ],
};
